import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import './AiModal.css';
import 'primeicons/primeicons.css';
import images from '../../../Utils/images';
import { useSelector } from 'react-redux';
import {
  getPromptBasedWorkflowDetails,
  generatepromptBasedWorkflowDetails,
} from "../../../Services"
import { Tooltip } from '@mui/material';
import HEImages from '../../../Pages/CreatorNew/Components/HEImages';
import { getImagePath } from '../../../Utils';
import { FaRegCopy } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { eventsend } from '../../../Config/analyticsFunctions';

const AiModal = ({
  show,
  onClose,
  nodes,
  edges,
  setNodes,
  setEdges,
  // isResponseLoading,
  setisResponseLoading,
  flowID,
  setLocalChat,
  localChat,
  flowCreated,
  isWorkflowIdCreated,
  setWorkflowGeneratedByAI,

}: {
  show: boolean;
  onClose: (show: boolean) => void;
  nodes: any[];
  edges: any[];
  setNodes: React.Dispatch<React.SetStateAction<any[]>>;
  setEdges: React.Dispatch<React.SetStateAction<any[]>>;
  setisResponseLoading: (isResponseLoading: boolean) => void;
  flowID: string,
  setLocalChat: React.Dispatch<React.SetStateAction<any[]>>;
  localChat: any[];
  isWorkflowIdCreated: boolean,
  flowCreated: boolean,
  setWorkflowGeneratedByAI:(show: boolean) => void;
}) => {
  const localdata = useSelector((state: any) => state.main.localdata);
  const authtoken = useSelector((state: any) => state.main.auth_token);
  const agentdata = useSelector((state: any) => state.main.agentdata);
  const [isTagShow, setisTagShow] = useState(true);
  const [otherTags, setOtherTags] = useState(false);

  const user = agentdata ?? localdata;
  const [loader, setLoader] = useState(true);
  const [chat, setChat] = useState([]);
  const [query, setQuery] = useState('');
  const messagesEndRef = useRef<HTMLDivElement | null>(null);

  const [selectedTag, setSelectedTag] = useState<string | null>(null);

  const tags = [
    { label: 'Facebook Lead', example: 'For every Facebook lead, add it to a label and send a WhatsApp template' },
    { label: 'Shopify Customer', example: 'When a new Shopify customer is created, send a welcome email.' },
    { label: 'Incoming WhatsApp', example: 'For every incoming WhatsApp message, create a support ticket.' },
    { label: 'Support Assistant', example: 'Automatically assign unresolved support tickets to available agents.' },
    { label: 'Booking Assistant', example: 'Send a confirmation email when a new booking is made.' },
  ];

  const TagAfterResponse = [
    { label: 'Improve Flow', example: 'Please Improve the flow' },
  ];

  const handleTagClick = (tag: any) => {
    eventsend("workflow_improve_clicked",{UserId:localdata?._id});
    setSelectedTag(tag.label);
    setQuery(tag.example);

    setTimeout(() => {
      resizeTextarea();
    }, 0);
  };

  useEffect(() => {
    if (show) {
      getHistoryApiCall();
    }
  }, [show]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chat, localChat, show]);


  console.log("chattt", chat, loader, user)

  const getHistoryApiCall = async () => {
    if (!flowID || (!isWorkflowIdCreated && flowCreated && flowID)) {
      return;
    }
    const token = authtoken;
    const data: any = {
      _id: flowID
    }
    await getPromptBasedWorkflowDetails(data, token)?.then((res) => {
      setisTagShow(false);
      setOtherTags(true);

      if (res?.flag) {
        console.log(res.data)
        setChat(res?.data);
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  };

  const handleSend = async () => {
    eventsend("prompt_entered",{UserId:localdata?._id})
    if (!query.trim()) return;

    setisResponseLoading(true);

    const currentQuery = query;
    setQuery("");
    setSelectedTag(null);

    const userMessage = {
      _id: (Date.now() + 1).toString(),
      content: currentQuery,
      role: 'user',
      isError: false,
      isLoading: false,
    };

    const loadingMessage = {
      _id: (Date.now() + 1).toString(),
      content: 'Thinking...',
      role: 'assistant',
      isError: false,
      isLoading: true,
    };

    if (!flowID) {
      setLocalChat((prev: any) => [...prev, userMessage, loadingMessage]);
    } else {
      setChat((prev: any): any => [...prev, userMessage, loadingMessage]);
    }

    try {
      const data = {
        content: currentQuery,
        role: "user",
        nodes,
        edges,
        workflowId: flowID || "",
        priviousContext: allMessages || [],
      };

      const res = await generatepromptBasedWorkflowDetails(authtoken, data);

      if (res && res.flag === true && res.data) {
        eventsend("workflow_generated_from_prompt",{UserId:localdata?._id});
        setWorkflowGeneratedByAI(true);
        setisTagShow(false);
        setOtherTags(true);

        const aiResponse = {
          content: res.data.content,
          role: 'assistant',
          nodes: res.data.nodes,
          edges: res.data.edges,
          isError: false,
          isLoading: false,
        };

        if (!flowID) {
          setLocalChat((prev: any) => {
            const updated = [...prev];
            updated[updated.length - 1] = aiResponse;
            return updated;
          });
        } else {
          setChat((prev: any) => {
            const updated: any = [...prev];
            updated[updated.length - 1] = aiResponse;
            return updated;
          });
        }

        if (res.data.nodes?.length > 0 && res.data.edges?.length > 0) {
          setNodes(res.data.nodes);
          setEdges(res.data.edges);
        }
        else {
          setNodes([]);
          setEdges([]);
        }

      } else {
        throw new Error("Invalid response from server");
      }

    } catch (err: any) {
      console.error("Error during AI response:", err);
      eventsend("workflow_generation_failed",{UserId:localdata?._id})
      const errorMessage = err?.message || "Something went wrong.";

      const errorResponse = {
        content: errorMessage,
        role: 'assistant',
        isError: true,
        isLoading: false,
      };

      if (!flowID) {
        setLocalChat((prev: any) => {
          const updated = [...prev];
          updated[updated.length - 1] = errorResponse;
          return updated;
        });
      } else {
        setChat((prev: any) => {
          const updated: any = [...prev];
          updated[updated.length - 1] = errorResponse;
          return updated;
        });
      }

      toast.error(errorMessage);
    } finally {
      setisResponseLoading(false);
    }
  };


  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard');
  };

  const initialMessage = {
    _id: 'initial',
    content: `Hi,

I am IRA. Your ai assistant in Cheerio.

I can help you in creating powerful user journeys and automate your workflows. Whether you need assistance generating a new workflow, or exploring the example workflows, I am here to assist.

What should we do today?`,
    role: 'assistant',
    isError: false
  };

  // const allMessages = (!isWorkflowIdCreated && !flowCreated && flowID) ? [initialMessage, ...chat] : [initialMessage, ...localChat];
  const allMessages = ((!isWorkflowIdCreated && flowCreated && flowID) || (!isWorkflowIdCreated && !flowCreated && !flowID)) ? [initialMessage, ...localChat] : [initialMessage, ...chat];

  const resizeTextarea = () => {
    const textarea = document.querySelector(".ai-input") as HTMLTextAreaElement;
    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setQuery(e.target.value);
    resizeTextarea();
  };


  return (
    <Modal
      show={show}
      onHide={() => onClose(false)}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="ai-modal-custom"
      contentClassName="ai-modal-content"
    >
      <div className="ai-modal-body">
        {/* Header */}
        <div className="ai-modal-header">
          <h5 className="ai-title">ASK AI</h5>
          <div className="ai-header-right">
            <i className="pi pi-question-circle"></i>
            <img
              src={images.CMClose}
              height={25}
              width={25}
              style={{ cursor: 'pointer' }}
              onClick={() => onClose(false)}
            />
          </div>
        </div>

        <hr />

        <div className="ai-messages">
          {allMessages.map((message: any) => (
            <div
              ref={messagesEndRef}
              key={message._id}
              className="message-bubble ai-message"
            >
              {/* Avatar */}
              {message.role === 'assistant' ? (
                <div className="message-avatar ai-avatar">
                  <img
                    src={images.GPTNEW}
                    alt="AI"
                    style={{ width: '115%', height: '115%', borderRadius: '50%', marginTop: 4 }}
                  />
                </div>
              ) : (
                <div className="message-avatar">
                  <HEImages
                    style={{ width: '32px', height: '32px', borderRadius: '50%' }}
                    userGeneratedSrc={
                      agentdata?.profileImg
                        ? agentdata?.profileImg
                        : getImagePath(localdata?.picture)
                    }
                  />
                </div>
              )}

              <div className="message-content-wrapper">
                <div className="message-content">
                  <div
                    style={{
                      whiteSpace: 'pre-wrap',
                      color: message?.isError ? 'red' : 'black'
                    }}
                  >
                    {message?.isLoading ? 'Preparing workflow...' : message?.content}
                  </div>
                </div>

                {!message?.isLoading && (
                  <div className="message-actions">
                    <Tooltip title="Copy">
                      <FaRegCopy
                        className="copy-icon"
                        onClick={() => copyToClipboard(message?.content)}
                      />
                    </Tooltip>
                  </div>
                )}
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        {isTagShow && (
          <div className="ai-tags">
            {tags.map((tag, index) => (
              <button
                key={index}
                className={`ai-tag ${selectedTag === tag.label ? 'selected' : ''}`}
                onClick={() => handleTagClick(tag)}
              >
                <span className="ai-tag-text">{tag.label}</span>
                <i className="pi pi-chevron-right"></i>
              </button>
            ))}
          </div>
        )}

        {otherTags && (
          <div className="ai-tags">
            {TagAfterResponse.map((tag, index) => (
              <button
                key={index}
                className={`ai-tag ${selectedTag === tag.label ? 'selected' : ''}`}
                onClick={() => handleTagClick(tag)}
              >
                <span className="ai-tag-text">{tag.label}</span>
                <i className="pi pi-chevron-right"></i>
              </button>
            ))}
          </div>
        )}


        <div className="ai-input-wrapper">
          <div className="ai-input-container">
            <textarea
              placeholder="Describe your workflow"
              className="ai-input"
              value={query}
              onInput={handleInput}
              onKeyPress={handleKeyPress}
              rows={1}
            />
            <button
              className="send-btn-inside"
              onClick={handleSend}
              disabled={!query.trim()}
            >
              <i className="pi pi-send"></i>
            </button>
          </div>
        </div>



      </div>
    </Modal>
  );
};

export default AiModal;